export default __webpack_public_path__ + "cc6105eeaf572f52e621df62f95ab5fd.png";